module.exports = __webpack_public_path__ + "media/application/images/news/intro_images/canada-0b33db8886efec6fd32f771753e77242.jpg";